document.addEventListener('DOMContentLoaded', function () {
  const productList = document.querySelector('.product-grid');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');
  const totalProducts = document.querySelectorAll('.grid__item').length;
  const itemsPerPage = 3; // Show 3 items per row
  let currentIndex = 0;

  // Function to update the product list view
  function updateProductList() {
    const maxIndex = Math.floor(totalProducts / itemsPerPage) - 1;
    productList.style.transform = `translateX(-${(currentIndex * 100) / itemsPerPage}%)`;

    // Disable buttons when reaching the first or last slide
    nextBtn.disabled = currentIndex >= maxIndex;
    prevBtn.disabled = currentIndex <= 0;
  }

  // Function to load the next set of products dynamically
  function loadNextProducts() {
    if (currentIndex < Math.floor(totalProducts / itemsPerPage) - 1) {
      currentIndex++;
      updateProductList();
    } else {
      currentIndex = 0; // Reset to the first product when end is reached
      updateProductList();
    }
  }

  // Function to load the previous set of products dynamically
  function loadPrevProducts() {
    if (currentIndex > 0) {
      currentIndex--;
      updateProductList();
    } else {
      currentIndex = Math.floor(totalProducts / itemsPerPage) - 1; // Go to the last set of products
      updateProductList();
    }
  }

  // Next button functionality
  nextBtn.addEventListener('click', loadNextProducts);

  // Prev button functionality
  prevBtn.addEventListener('click', loadPrevProducts);

  // Initialize the product list view
  updateProductList();
});
